export const BUTTON_CLASS_OVERRIDES =
  'bg-stone-200 dark:bg-stone-200 text-stone-950 dark:text-stone-950 hover:bg-stone-200 hover:border-stone-200 hover:dark:border-stone-200 hover:dark:bg-stone-200 hover:text-stone-950 hover:dark:text-stone-950';
